module.exports = Promise.all([__parcel__import__("2svxS"), __parcel__import__("8tRRG")]).then(() => parcelRequire('3pHq1'));